/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-link-icon-component.ts
 *
 * Created by kyang on 6/7/19.
 */

function PackageLinkIconController(
    this: JS5Object,
    $element: JS5Object,
    $location: JS5Object,
    PackageResourceFactory: JS5Object,
    PaginationService: JS5Object,
    SidebarService: JS5Object) {

    let gettingPackageInfo: boolean;
    let navigationStarted: boolean;

    this.onClick = ($event: JS5Object) => {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        if (gettingPackageInfo || navigationStarted) {
            return;
        }

        gettingPackageInfo = true;
        this.onNavigationStarted();
        if (this.packageIdList === undefined || this.packageIdList.length === 1) {
            PackageResourceFactory.get({ id: this.packageId, view: 'NORMAL' }).$promise.then((pkgData: JS5Object) => {
                if (!gettingPackageInfo) {
                    return;
                }

                let url = '';
                if (pkgData.parentPackageId) {
                    url = `/packages/package/edit/${pkgData.parentPackageId}/liveClip?livePackageId=${pkgData.id}`;
                } else {
                    url = `/packages/package/edit/${pkgData.id}/metadata`;
                }
                navigationStarted = true;
                SidebarService.goToUrl(url, 'packages', SidebarService.getSelectedItem());
                this.onNavigationEnded();
            });
        } else {
            navigationStarted = true;
            let packages = this.packageIdList.join(',')
            let url = `/packages?searchText=${packages}`;

            //
            // If we don't reset the pagination, the package
            // manager will go to the same page as the WF search
            // view.
            //
            // We'd rather save the pagination state where it may
            // be recalled per sidebar item... for now this is a
            // slight bug.
            //
            PaginationService.resetToDefaultValues();

            SidebarService.goToUrl(url, 'packages', SidebarService.getSelectedItem());
            this.onNavigationEnded();
        }
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        gettingPackageInfo = false;
        navigationStarted = false;
        $element.on('click', this.onClick);
    };

    this.$onDestroy = () => {
        if (gettingPackageInfo) {
            gettingPackageInfo = false;
        }
        if (navigationStarted) {
            SidebarService.ignoreNavUpdates = false;
        }
    }
}

angular.module('prism-ui.components').component(
    'packageLinkIcon',
    {
        controller: PackageLinkIconController,
        templateUrl: 'components/visual/icon/packageLinkIcon/package-link-icon-template.html',
        bindings: {
            packageIdList: '<',
            packageId: '<',
            onNavigationStarted: '&',
            onNavigationEnded: '&'
        }
    });
